import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { RubricaInsertPRModalComponent } from './rubrica-insert-pr-modal';

export const RubricaInsertPRModalModule: string = ng
    .module('rubrica-insert-pr-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('rubricaInsertPRModalComponent', RubricaInsertPRModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/rubrica-insert-pr-modal/rubrica-insert-pr-modal.module.ts